export enum SidebarAction {
  SendBackwards = "send-backwards",
  BringForward = "bring-forward",
  SendToBack = "send-to-back",
  BringToFront = "bring-to-top",
  removeSelection = "remove-selection",
}
